<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class>
    <div
      ref="activity"
      style="background: linear-gradient(180deg, #90D12E 0%, rgba(144,209,46,0.2) 100%);padding:60px 16px 100px;min-height: 100vh;"
      :class="!isWeiXin()  ? 'mainMar':'mainNot'"
    >
     <nav-bar
        :title="langEnv==3?activityList.activityName:activityList.activityNameEn"
        :goBack="goBack"
        :bgc="'background:#90D12E'"
        :isFixed="true"
      ></nav-bar>
      <div class="subscribe-content" >

        <div class="margin-b24" v-if="activityList.collectInfo && activityList.collectInfo.name">
          <div class="margin-b">{{$t("姓名")}}：</div>
          <input :placeholder="$t('請輸入')+$t('姓名')" :disabled='isRepeat' inputType="name" v-model="inputData.userName"/>
        </div>
        <div class="margin-b24" v-if="activityList.collectInfo &&activityList.collectInfo.phone">
          <div class="margin-b">{{$t('電話')}}：</div>
          <div class="areaCode" @click="show = true">{{ phoneLabel }}<img src="@/assets/icons/arrow-rightactive.png"
                alt="" />
            </div>
          <input :placeholder="$t('請輸入')+$t('電話')" :disabled='isRepeat' inputType="phoneNum" v-model="inputData.phoneNumber"/>
        </div>
        <div class="margin-b24" v-if="activityList.collectInfo &&activityList.collectInfo.email">
          <div class="margin-b">{{$t('郵箱')}}：</div>
          <input :placeholder="$t('請輸入')+$t('郵箱')" :disabled='isRepeat' inputType="phoneNum" v-model="inputData.email"/>
        </div>
        <div class="margin-b24" v-if="activityList.collectInfo &&activityList.collectInfo.clinicName">
          <div class="margin-b">{{$t("診所名稱")}}：</div>
          <input :placeholder="$t('請輸入')+$t('診所名稱')" :disabled='isRepeat' inputType="phoneNum" v-model="inputData.clinicName"/>
        </div>

  

        <div class="margin-b24">
        <div v-if="activityList.collectInfo && activityList.collectInfo.area">
        <div  class="margin-b">{{$t("所在地區")}}：</div>
        <div class="margin-b24" style="background-color: #F8F8F8;  border-radius: 8px;">
          <div class="Pleaseselect" @click="getpicker"><div>{{address.length>0? address.join('/') :$t('請選擇')}}</div><img class="ic-rt" src="../../assets/icons/ic-right.png" alt /></div>
        </div>
      </div>

  

  

        <div>
          <textarea v-if="activityList.collectInfo && activityList.collectInfo.address" class="address" :disabled='isRepeat' v-model="addressinfo" style="padding-bottom:90px" type="textarea" :placeholder="$t('請輸入')+$t('詳細地址')" inputType="address" />
        </div>

        
        <div class="margin-b24" v-if="activityList.collectInfo && activityList.collectInfo.willOpenTime">
          <div class="margin-b">{{$t("預計開業時間")}}：</div>
          <div class="margin-b24" style="background-color: #F8F8F8;  border-radius: 8px;">
          <div class="Pleaseselect" @click="getTimepicker"><div>{{timeLabel ? timeLabel : $t('請選擇')}}</div><img class="ic-rt" src="../../assets/icons/ic-right.png" alt /></div>
        </div>
        </div>



        <div class="margin-b24" v-if="activityList.collectInfo && activityList.collectInfo.yayiAmount">
          <div class="margin-b">{{$t("牙椅數量")}}：</div>
          <input :placeholder="$t('請輸入')" :disabled='isRepeat' inputType="phoneNum" v-model.number="inputData.yayiAmount"/>
        </div>
      </div>
      <div  v-if="activityList.intentionProduct">
        <div  class="margin-b">{{$t("意向產品")}}：</div>
        <div  style="margin-bottom: 20px;">



        <div class="productList">
        <span  ref="spanall" style="margin-right: 20px;" class="product"  v-for="(item,index) in goods" :key="index">
        <div
         @click="handleGoodsChange(index)"
          :class="`mmmckeck-box${item.checked? ' active-box' : ''}`"/>
         <span style="vertical-align: middle;">{{ $t(item.value) }}</span>  
          </span>
        </div>
        
       
        </div>
        

      </div>

        <a v-if="!isRepeat" @click="save('1')" class="btn btn-active">{{$t("提交")}}</a>
        <a v-else  class="btn btn-active" style="background-color:#BCE382">{{$t("已預約")}}</a>
        <div class="notice">{{inputData.error}}</div>
      </div>
    </div>
    <addressCascader :isShow="isShow" @handleClose="handleClose" @handleAreaCode="handleAreaCode"></addressCascader>

    <div class="modal" v-if="showTimepicker" @click.self="showTimepicker=false">
      <van-datetime-picker
        class="foot-picker"
       type="year-month"
       :confirm-button-text="$t('確認')"
       :cancel-button-text="$t('取消')"
      v-model="currentDate"
      @cancel="showTimepicker=false"
      @confirm="handleTimePickerConfirm"
    ></van-datetime-picker>
    </div>
   <van-popup
      v-model:show="show"
      position="bottom"
      :style="{ height: '40%', borderRadius: '16px 16px 0 0' }"
    >
      <div class="titleArea">
        <div></div>
        <div>{{ $t("國家地區") }}</div>
        <div class="close">
          <img
            @click="show = false"
            style="width: 100%"
            src="@/assets/icons/ic_Close@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="phone-list">
        <div
          :class="['phone-item', { actvie: item.code == selectPhone }]"
          v-for="item in phoneCode"
          :key="item.value"
          @click="handlePhoneCode(item)"
        >
          <div class="phone-text">{{ item.name }}</div>
          <img
            class="phone-check"
            v-if="item.code == selectPhone"
            src="@/assets/icons/check.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex"
import mixins from "@/utils/mixins.js";
import { submit,queryActivityInfo } from "@/api/Appointment.js";
import dayjs from 'dayjs';
export default {
  data: () => ({
    inputData: {
      userName: "",
      phoneNumber: "",
      clinicName: "",
      address: "",
      region: "",
      activityId: "",
      intentionProduct: "",
      yayiAmount: "",
      willOpenTime: "",
      areaCode: "",
      province: "",
      city: "",
      district: "",
    },
    isShow: null,
    addressinfo: "",
    address: [],
    location: [],
    goods: [{ value: "产品1", label: "1" }],
    goodsanchor: [],
    isRepeat: false,
    activityList: {},
    checkVal: [],
    currentDate:null,
    phoneLabel: "HK(+852)",
      show: false,
      columns: [
        {
          value: "1",
          label: "HK(+852)"
        },
        {
          value: "2",
          label: "MO(+853)"
        }
      ],
      selectPhone: "1",
    time: [],
    timeAnchor: [],
    timeLabel: "",
    years: [],
    showTimepicker: false,
    months: [],
    langEnv:2
  }),
  computed: {
    addressList() {
      return this.$store.getters.addressList;
    },
    ...mapState("user", ["phoneCode"])
  },
  mixins: [mixins],
  async created() {
     await this.$store.dispatch("user/getPhoneCode");
    this.inputData.activityId = this.$route.query.activityId;
    if (this.$route.query.langEnv) {
      localStorage.setItem("langEnv", this.$route.query.langEnv)
    }
    this.getactivityList()
  },
  mounted() {},
  methods: {
    goBack() {
        this.$router.back();
    },
    handlePhoneCode(item) {
      this.selectPhone = item.code;
      this.show = false;
      this.params.areaCode = item.code;
      this.phoneLabel = item.name;
    },
    handleAreaCode (data) {
      const areaList = data.filter(item => item.value !== "1")
      areaList.forEach((item, index) => {
        if (index === 0) {
          this.inputData.province = item.label
        } else if (index === 1) {
          this.inputData.city = item.label
        } else if (index === 2) {
          this.inputData.district = item.label
        }
      })
      const res = areaList.map(items => items.label)
      this.address = res
    },
    handleClose (data) {
      this.isShow = false
    },
    handleTimePickerConfirm(val) {
      this.timeLabel = dayjs(val).format("YYYY-MM")
      this.showTimepicker = false
    },
    getTimepicker() {
      if (this.isRepeat) {
        return;
      }
      this.showTimepicker=true
    },
    handleGoodsChange(val) {
      this.goods[val].checked = !this.goods[val].checked
    },
    handlePickergoodsConfirm(val) {
      console.log(val);
      this.inputData.intentionProduct = val[0].value;
    },
    getactivityList() {
      return new Promise((resolve) => {
       queryActivityInfo(this.$route.query.activityId).then((res) => {
            this.activityList = res.data;
            this.activityList.collectInfo = JSON.parse(
              this.activityList.collectInfo
            );
            this.goods = res.data.intentionProduct
              .split("、")
              .map((item, index) => {
                return { value: item, label: index };
              });
              this.langEnv=localStorage.getItem('langEnv')
            if  (this.langEnv==3) {
              document.title = this.activityList.activityName;
            }else{
              document.title = this.activityList.activityNameEn;
            }
            console.log(this.activityList);
            resolve();
          }
        );
      });
    },
    getpicker() {
      if (this.isRepeat) {
        return;
      }
      this.isShow=true
    },
    save(type) {
      // if(type==='2') return this.$toast('请勿重复提交预约')
      if (type === "1") {
        this.inputData.region = JSON.stringify(this.address.map((item,index)=>{
          return {
            index,
            value: item
          }
        }));
        this.inputData.address =
          this.address.join("-") + "," + this.addressinfo;
        this.inputData.intentionProduct = this.goods.filter(
          (item) => item.checked
        ).map((item) => item.value).join("、");
        this.inputData.willOpenTime = this.timeLabel;
        //提交
        if (!this.inputData.userName && this.activityList.collectInfo.name) {
          return this.$toast(this.$t("請輸入")+this.$t("姓名"));
        }
        if (
          !this.inputData.clinicName &&
          this.activityList.collectInfo.clinicName
        ) {
          return this.$toast(this.$t("請輸入")+this.$t("診所名稱"));
        }
        if (
          !this.inputData.yayiAmount &&
          this.activityList.collectInfo.yayiAmount
        ) {
          return this.$toast(this.$t("請輸入")+this.$t("牙椅數量"));
        }
        if (
          !this.inputData.willOpenTime &&
          this.activityList.collectInfo.willOpenTime
        ) {
          return this.$toast(this.$t("請選擇")+this.$t("預計開業時間"));
        }
        if (this.address.length < 1 && this.activityList.collectInfo.area) {
          return this.$toast(this.$t("請選擇")+this.$t("地區"));
        }
        if (!this.addressinfo && this.activityList.collectInfo.address) {
          return this.$toast(this.$t("請輸入")+this.$t("詳細地址"));
        }
        if (this.goods.filter(item => item.checked).length === 0 && this.activityList.intentionProduct) {
          return this.$toast(this.$t("請選擇")+this.$t("意向產品"));
        }
        var reg = /^([5|6|8|9])\d{7}$/;
        if (
          !reg.test(this.inputData.phoneNumber) &&
          this.activityList.collectInfo.phone
        ) {
          this.$toast(this.$t("請輸入")+this.$t("正確手機號碼"));
          return;
        }
        let eamilReg= /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (
          !eamilReg.test(this.inputData.email) &&
          this.activityList.collectInfo.email
        ) {
          this.$toast(this.$t("請輸入")+this.$t("有效電子郵箱地址"));
          return;
        }
        submit(this.inputData).then((res) => {
          console.log(res);
          if (res.resultID === 1200) {
            this.$toast(this.$t("預約成功"));
          } else {
            this.$toast(this.$t("請勿重復預約"));
            this.isRepeat = true;
            this.inputData.phoneNumber = res.data.phoneNumber;
            this.inputData.areaCode = res.data.areaCode;
            this.inputData.clinicName = res.data.clinicName;
            this.inputData.userName = res.data.userName;
            this.inputData.address = res.data.address;
            this.inputData.willOpenTime = res.data.willOpenTime;
            this.inputData.yayiAmount = res.data.yayiAmount;
            this.timeLabel = res.data.willOpenTime;
            this.addressinfo = res.data.address.split(",")[1];
            const locations = JSON.parse(res.data.region);
            this.address = locations.map((item) => item.value);
            console.log(locations);
            // todo回显意向产品
            res.data.intentionProduct.split("、").forEach((item) => {
              this.goods.forEach((good) => {
                if (good.value === item) {
                  good.checked = true;
                }
              });
            });
          }
        });
        this.isRepeat = true;
        console.log(this.inputData);
        console.log(this.address);
      }
    },
    headerBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.btn{
    width: 92%;
    height: 50px;
    margin: 10px auto 0;
    line-height: 50px;
    border-radius: 2px;
    border: 0;
    display: block;
    color: #fff;
    text-align: center
}
.subscribe-content {
  padding: 20px 20px 0px;
  background-color: #fff;
  border-radius: 16px;
}
.btn-active {
  border-radius: 8px 8px 8px 8px;
  width: 100%;
  margin-top: 33px;
  font-size: 16px;
  background: #90d12e;
}
.margin-b {
  margin-bottom: 12px;
}
.margin-b24 {
  margin-bottom: 24px;
}
input {
  border: 1px transparent solid;
  border-radius: 8px;
  padding: 12px 16px;
  line-height: 16px;
  background-color: #f8f8f8;
  outline: none;
  width: 100%;
  caret-color: #90d12e;
}
input:focus {
  border: 1px solid #90d12e;
  outline: none;
}
.Pleaseselect {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 12px;
  align-items: center;
}
.ic-rt {
  height: 16px;
  width: 16px;
}
.address:focus {
  border: 1px solid #90d12e;
  outline: none;
}
.address {
  border: 1px transparent solid;
  border-radius: 8px;
  padding: 12px 16px;
  line-height: 16px;
  background-color: #f8f8f8;
  outline: none;
  width: 100%;
  caret-color: #90d12e;
}
.pet-select {
  border: 1px transparent solid;
  border-radius: 8px;
  padding: 12px 16px;
  line-height: 16px;
  background-color: #f8f8f8;
  outline: none;
  width: 100%;
  caret-color: #90d12e;
}
.notice{
   line-height: .5rem;
    color: #f23030;
    min-height: 1.5rem;
    width: 92%;
    margin: .07rem auto 0
}
.select-option {
  border: solid 1px #e4e7ed;
  border-radius: 2px;
  background-color: #ffffff;
  margin-top: 10px;
  padding: 12px 16px;
}
.checkboxinp {
  width: auto;
}
/* .checkboxinp:checked{
  background-color: #90D12E;
} */
input[type="checkbox"] {
  width: 14px;
  height: 14px;
  position: relative;
  vertical-align: middle;
  padding: 0;
}
input[type="checkbox"]::after {
      position: absolute;
    top: 0;
    color: #000;
    width: 14px;
    height: 14px;
    display: inline-block;
    visibility: visible;
    padding-left: 0;
    text-align: center;
    content: " ";
}
.areaCode {
      margin: 20px 0;
      font-weight: 400;
      font-size: 15px;
      color: #1A1A1A;
      line-height: 24px;
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
      }
    }
.ioscheckedinput[type="checkbox"]:checked::after {
  content: "✓";
  color: #fff;
  font-size: 10px;
  line-height: 14px;
  border-radius: 2px;
  background-color: #90d12e;
}
.productList {
  display: flex;
  flex-wrap: wrap;
}
.productList .product {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.productList .product:last-child {
  margin-right: 0 !important;
}
.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .foot-picker{
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
.titleArea {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.9);
  line-height: 24px;

  .close {
    width: 20px;
  }
}
.phone-list {
  padding: 20px 16px;
  .actvie {
    border: 2px solid #90d12e !important;
  }
  .phone-item {
    padding: 20px;
    position: relative;
    background: #f8f8f8;
    border-radius: 8px 8px 8px 8px;
    margin-bottom: 12px;
    border: 2px solid transparent;
    .phone-text {
      font-size: 16px;
      color: #1a1a1a;
      line-height: 16px;
      text-align: center;
    }
    .phone-check {
      position: absolute;
      width: 24px;
      bottom: -1px;
      right: -1px;
    }
  }
}
.mmmckeck-box{
  width: 14px;
  height: 14px;
  background: #fff;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-right: 2px;
}
.active-box{
  background: #90d12e;
  border: 1px solid #90d12e;
  border-radius: 2px;
  &::after{
    content: " ";
    position: absolute;
    width: 3px;
    height: 7px;
    border: 2px solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    top: 1px;
    left: 3px;

  }
}
</style>